import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import { inject, observer } from 'mobx-react';
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import { buildNotificationLink, getNotificationIcon, getNotificationColorClass } from '~/utils/commonMethods';


export class ShowNotifications extends Component {
    renderRow(row) {
        const { commonStore } = this.props;
        let dateTimeRules = commonStore.config.client && commonStore.config.client.data &&
            commonStore.config.client.data.dateTimeRules ?
            { ...commonStore.config.client.data.dateTimeRules }
            : { short_date_format: "DD.MM.YYYY", time_format: "hh:mm" };
        const link = buildNotificationLink(row?.data?.context);
        return (
            <Link
                to={link.to}
                state={link.state}
                className={`notification-item d-flex align-items-start text-decoration-none bg-white position-relative ${row?.is_unread ? "unread" : "read"}`}
                onClick={() => this.closeNotification("notifications", row.id)}
            >
                <div className="notify-symbol position-relative"><span className={`btn h-100 w-100 p-0 border-0 d-flex align-items-center justify-content-center ${getNotificationColorClass(row?.data?.context?.source)}`}><i className={`fa ${getNotificationIcon(row?.data?.context?.source)}`}></i></span></div>
                <div className="notify-text mx-2">
                    <span className=''>{moment(new Date(row.created_at)).format(dateTimeRules.short_date_format).toUpperCase()}</span>
                    <span className='mx-1'>{moment(new Date(row.created_at)).format(dateTimeRules.time_format).toUpperCase()}</span>
                    <p className='fw-bold'>{row.message}</p>
                </div>
                <div className="notify-arrow d-flex align-items-center justify-content-center"><i className="fa fa-angle-right"></i></div>
                {!row?.is_unread && <span className="notify-seen-label">{this.props.t('Seen')}</span>}
            </Link>
        );
    }

    closeNotification(type, id) {
        if (type === "notifications") this.props.userStore.hideNotificationDock();
        else this.props.userStore.hideMessageNotificationDock();
        this.props.userStore.readNotifications(id);
    }

    renderMessageRow(row) {
        const { commonStore } = this.props;
        let dateTimeRules = commonStore.config.client && commonStore.config.client.data &&
            commonStore.config.client.data.dateTimeRules ?
            { ...commonStore.config.client.data.dateTimeRules }
            : { short_date_format: "DD.MM.YYYY", time_format: "hh:mm" };
        return (
            row?.data?.context?.source === 'chat' ?
                (
                    <>
                        <Link
                            to={`/admin/chat/${row?.data?.context?.room}` || ""}
                            className={`notification-item d-flex align-items-start text-decoration-none bg-white position-relative ${row?.is_unread ? "unread" : "read"}`}
                            onClick={() => this.closeNotification("messages", row.id)}
                        >
                            <div className="notify-symbol position-relative"><i className="btn btn-danger h-100 w-100 p-0 border-0 d-flex align-items-center justify-content-center">{row?.data?.context?.projectName?.replace('and', '').split(" ").map(obj => obj[0]).join('').substring(0, 3).toUpperCase() || "M"}</i></div>
                            <div className="chat-notifications-list mx-2">
                                <p className='room-name fw-bold'>
                                    {row?.data?.context?.projectName ? `${row.data.context.projectName} : ` : ""}
                                    <span className="msg text-break">{row.message}</span>
                                </p>
                                <span className='timestamp fw-bold'>{moment(new Date(row.created_at)).format(dateTimeRules.short_date_format)}</span>
                                <span className='timestamp fw-bold mx-1'>{moment(new Date(row.created_at)).format(dateTimeRules.time_format)}</span>
                            </div>
                            <div className="notify-arrow d-flex align-items-center justify-content-center"><i className="fa fa-angle-right"></i></div>
                            {!row?.is_unread && <span className="notify-seen-label">{this.props.t('Seen')}</span>}
                        </Link>
                    </>
                ) :
                (
                    <>
                        {
                            <Link
                                to={row?.data?.context?.isChatRoomDeleted ? "" : `/admin/privatechat/${row?.data?.context?.room || ''}`}
                                className={`notification-item d-flex align-items-start text-decoration-none bg-white position-relative ${row?.is_unread ? "unread" : "read"}`}
                                onClick={() => this.closeNotification("messages", row.id)}
                            >
                                <div className="notify-symbol position-relative"><i className="btn btn-danger h-100 w-100 p-0 border-0 d-flex align-items-center justify-content-center">{row?.data?.context?.roomName?.replace('and', '').split(" ").map(obj => obj[0]).join('').substring(0, 3).toLowerCase() || "M"}</i></div>
                                <div className="chat-notifications-list mx-2">
                                    <p className='room-name fw-bold'>
                                        {row?.data?.context?.roomName ? `${row?.data?.context?.roomName} : ` : ""}
                                        <span className="msg text-break">{row.message}</span>
                                    </p>
                                    <span className='timestamp fw-bold'>{moment(new Date(row.created_at)).format(dateTimeRules.short_date_format)}</span>
                                    <span className='timestamp fw-bold mx-1'>{moment(new Date(row.created_at)).format(dateTimeRules.time_format)}</span>
                                </div>
                                <div className="notify-arrow d-flex align-items-center justify-content-center"><i className="fa fa-angle-right"></i></div>
                                {!row?.is_unread && <span className="notify-seen-label">{this.props.t('Seen')}</span>}
                            </Link>
                        }
                    </>
                )
        );
    }
    render() {
        const { userStore, notificationType } = this.props;
        if (!userStore.dockNotifications) return null;
        if (!userStore.messageNotifications) return null;
        return (
            <>
                {
                    notificationType === "notifications" ?
                        (
                            <>
                                {userStore.dockNotifications.map(row => (
                                    <div key={row.id}>
                                        <div>{this.renderRow(row)}</div>
                                    </div>
                                ))}
                            </>
                        )
                        :
                        (
                            <>
                                {userStore.messageNotifications.map(row => (
                                    <div key={row.id}>
                                        <div>{this.renderMessageRow(row)}</div>
                                    </div>
                                ))}
                            </>
                        )
                }
            </>
        )
    }
}

export default inject('commonStore', 'userStore')(applicationRouter(withLocalization(observer(ShowNotifications))));
